export default __webpack_public_path__ + "static/media/soundcloud1.77518e98.svg";